export default __webpack_public_path__ + "static/media/stake-more-zen-ust.e8888f6a.svg";